import { IconCircleCheck, IconExclamationCircle } from "@tabler/icons-react";
import type { FC } from "react";
import { useAppSelector } from "../../hooks/hook.js";
import { NotificationType, selectNotifications } from "./notificationsSlice.js";

// TODO: Rebuild on React Aria's toast primitives once they leave alpha (still
// UNSTABLE_ToastRegion/Queue in react-aria-components 1.18). Its region sets
// `data-react-aria-top-layer`, which React Aria excludes from the inert subtree
// it applies around an open modal — today a toast over a modal can't be clicked.
export const NotificationsOverlay: FC = () => {
  const notifications = useAppSelector(selectNotifications);

  return (
    <>
      {/* Global notification overlay rendered on top of app*/}
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 z-50 flex items-start p-6"
      >
        <div className="flex w-full flex-col items-end space-y-4">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 motion-safe:animate-nudge-up sm:motion-safe:animate-nudge-left"
            >
              <div className="p-4">
                <div className="flex items-start">
                  <div className="shrink-0">
                    {renderIcon(notification.type)}
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-foreground">
                      {notification.primaryMessage}
                    </p>
                    {notification.secondaryMessage && (
                      <p className="mt-1 text-sm text-muted-foreground">
                        {notification.secondaryMessage}
                      </p>
                    )}
                  </div>

                  {/* Restore this if we add sticky notifications that have to be dismissed
                    <div className="ml-4 flex shrink-0">
                      <button
                        type="button"
                        className="inline-flex rounded-md bg-white text-gray-400 hover:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        onClick={() => {
                          setShow(false);
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <IconX className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

function renderIcon(notificationType: NotificationType) {
  switch (notificationType) {
    case NotificationType.SUCCESS:
      return (
        <IconCircleCheck
          className="h-6 w-6 text-green-400"
          aria-hidden="true"
        />
      );
    case NotificationType.FAILURE:
      return (
        <IconExclamationCircle
          className="h-6 w-6 text-red-400"
          aria-hidden="true"
        />
      );
  }
}
